import React from "react";
import logo_eco from "../img/Logo eco by assur bon plan.png"
import logo_abp from "../img/Logo assur bon plan.png"
import logo_motard from "../img/motard4.png"
import DataDevis from "../dataDevis";
import cadenas from "../img/Cadenas.svg"
import mastercard from "../img/mastercard.svg"
import visa from "../img/visa.svg"
import certification from "../img/certification.svg"
import socgen from "../img/societe generale.svg"
import DataSolly from "../dataSolly";
import DataAxa from "../dataAxa"
import DataFma from "../dataFma"
import api from '../apiConnector'

export const CbLogos = (p) => <div className="cbLogo">
    <img src={cadenas}/> Paiement 100% sécurisé <img src={mastercard}/>
    <img src={visa}/><br/><img src={certification}/> Certifié <img src={socgen}/>
</div>

const showAxa = process.env.REACT_APP_SHOW_AXA === 'true'
const subsribeAxa = process.env.REACT_APP_SUBSCRIBE_AXA === 'true'
const envDev = process.env.REACT_APP_DEV === 'true'
const showFma = process.env.REACT_APP_SHOW_FMA === 'true'

export default class FrontRecap extends React.Component {
    
    constructor(props) {
        super(props);
    }

    value(field,deflt='') {
        const devis = this.props.devis
        const params = devis.params
        const type = devis.getType(field)
        if ( typeof type === 'object' ) {
            return type[params[field]] || deflt
        }

        return devis.getDisplayValue(field) || deflt
    }

    render() {

        const {setPage,devis,hasXena,hasSolly,hasAxa,axa,axaAlive,fma,hasFma} = this.props
        axa.setFancy('-',' €')
        const solly = devis.getSolly()
        const params = devis.params
        const selectedOptions = params.selectedOptions || []

        const selVehicle = params.fma_available ? params.fma_available[params.fma_selected] : false
        const selVehicleName = selVehicle ? selVehicle.marque+' '+selVehicle.modele+' '+selVehicle.cylindree : 'Non défini'

        const RowAggregate = ({children, separator = <td />}) => {
            const elements = React.Children.toArray(children);
            const list = elements
                .map((element, index) => [hasXena, hasSolly, hasAxa, hasFma][index] && element)
                .filter(Boolean)
            return (
                <tr>
                {list.reduce((acc, item) => (
                    <React.Fragment key={item.key}>{acc}{acc && separator}{item}</React.Fragment>
                ), null)}
                </tr>
            )
        }

        return <table className="recaptable">
                <thead>
                    <RowAggregate>
                        <th><img src={logo_eco}/></th>
                        <th><img src={logo_abp}/></th>
                        <th><img src={logo_motard}/></th>
                        <th>Assur Discount</th>
                    </RowAggregate>
                </thead>
                <tbody>
                    <RowAggregate>
                        <td>Récupitulatif</td>
                        <td>Récapitulatif</td>
                        <td>Récapitulatif</td>
                        <td>Récapitulatif</td>
                    </RowAggregate>
                    <RowAggregate>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span>
                            </label>
                            {( params.periodicite &&( !params.error )&& params.formule && devis.hasTarif())?<>
                                <label>Votre formule <b className="price">{devis.toPayMonthlyYearlyFormule()} €</b>
                                <span>
                                    <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                    <i>{DataDevis.zFormToDisplay[params.formule]}</i>
                                    {DataDevis.zFormToExplain[params.formule]}
                                </span>
                                </label>
                                <label>Vos options <b className="price">{devis.toPayMonthlyYearlyOptions()} €</b>
                                <span>
                                    {selectedOptions.map( code => <React.Fragment key={code}>{DataDevis.optionCodeToTitle[code]}<br/></React.Fragment>)}
                                    
                                </span>
                                </label>
                            </>:<>
                                <label>Offre indisponible sur cette formule</label>
                            </>}
                        </td>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span>
                            </label>
                            {( params.periodicite && params.formule && solly.hasTarifs() )?<>
                                <label>Votre formule <b className="price">{DataDevis.fancyPrice(solly.toPayMonthlyYearlyFormule())} €</b>
                                    <span>
                                        <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                        <i>{DataSolly.zFormToDisplay[params.formule]}</i>
                                        {DataSolly.zFormToExplain[params.formule]}
                                    </span>
                                </label>
                                <label>Vos options <b className="price">{DataDevis.fancyPrice(solly.toPayMonthlyYearlyOptions())} €</b>
                                    <span>
                                        
                                    </span>
                                </label>

                            </> : <label>Offre indisponible sur cette formule</label>}
                        </td>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{this.value('marque')} {this.value('modele')} ({this.value('cylindree')})</span>
                            </label>
                            {( params.periodicite && params.formule && axa.hasTarifs() )?<>
                                <label>Votre formule <b className="price">{axa.fancyPrice(axa.echeance())}</b>
                                    <span>
                                        <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                        <i>{axa.display()}</i>
                                        {axa.explain()}
                                    </span>
                                </label>
                                <label>Vos options <b className="price">{axa.fancyPrice(axa.toPayOptions())}</b>
                                <span>
                                    {selectedOptions.map( code => DataAxa.optionCodeToTitle[code] && <React.Fragment key={code}>{DataAxa.optionCodeToTitle[code]}<br/></React.Fragment>)}
                                </span>
                                </label>

                            </> : <label>Offre indisponible sur cette formule</label>}
                        </td>
                        <td>
                            <label>Votre deux-roues <a onClick={()=>{ setPage('vehicule') }}>Modifier</a>
                            <span>{selVehicleName}</span>
                            </label>
                            {( params.periodicite && params.formule && fma.hasTarifs() )?<>
                                <label>Votre formule <b className="price">{fma.fancyPrice(fma.echeance(false,false,true))}</b>
                                    <span>
                                        <b>{(params.periodicite=='M')?'Mensuel':'Annuel'}</b><br/>
                                        <i>{fma.display()}</i>
                                    </span>
                                </label>
                                <label>Vos options <b className="price">{fma.fancyPrice(fma.priceOptions())}</b>
                                <span>
                                    {selectedOptions.filter( code => fma.hasOption(code)).map( code => <React.Fragment key={code}>{DataFma.xenaOptionCodeToTitle[code]}<br/></React.Fragment>)}
                                </span>
                                </label>


                            </> : <label>Offre indisponible sur cette formule</label>}
                        </td>
                    </RowAggregate>
                    <RowAggregate>
                        <td className="prices">
                            { (( !params.error )&& devis.hasTarif())?<>
                                {(params.periodicite=='M')?<>
                                    <b>{devis.toPayMonthly()}</b> par mois<br/>
                                    <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{devis.toPayYearly()}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus

                                { this.props.enableClientSubscription ?
                                    <>
                                        <button
                                            className="subscribe"
                                            onClick={()=>this.props.setPage('details1')}>Souscrire cette offre</button>
                                        <CbLogos/>
                                    </>:<>
                                        <p>
                                            La souscription en ligne est temporairement fermée. Appelez-nous
                                            du lundi au vendredi de 9h à 19h.
                                        </p>
                                        <p><b><a href="tel:0974772861" style={{'color':'#4fb6e9'}}>Appelez-nous pour souscrire</a></b></p>
                                        <p className="telephone_left">
                                            <a href="tel:0974772861">09 74 77 28 61</a>
                                        </p>
                                    </>}

                                    <button 
                                        className="receive_devis"
                                        onClick={()=>this.props.setPage('receive')}
                                        >Enregistrer<br/>&<br/>Recevoir mon devis</button>

                                    {(params.periodicite=='M')?<p>
                                    * L'acompte de <b>{devis.toPay()} €</b> inclut les frais de gestion et de
                                    courtage ainsi que les deux premiers mois. Puis, par mois, à
                                    partir du 3ème mois : <b>{devis.toPayMonthly()} €</b></p>:<></>}
                                </>:<></>}
                        </td>
                        <td className="prices">
                            {solly.hasTarifs() ?<>

                                {(params.periodicite=='M')?<>
                                    <b>{DataDevis.fancyPrice(solly.toPayMonthly())}</b> par mois<br/>
                                    <b>{DataDevis.fancyPrice(solly.toPayYearly())}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{DataDevis.fancyPrice(solly.toPayYearly())}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus

                                <button
                                    className="subscribe"
                                    onClick={()=>setPage('subscribe_solly')}>Souscrire cette offre</button>
                                <CbLogos/>
                                <button 
                                    className="receive_devis"
                                    onClick={()=>this.props.setPage('receive2')}
                                    >Enregistrer<br/>&<br/>Recevoir mon devis</button>

                                    {(params.periodicite=='M')?<p>
                                    * L'acompte de <b>{DataDevis.fancyPrice(solly.toPay())} €</b> inclut les frais de gestion et de
                                    courtage ainsi que le premier mois. Puis, par mois, à
                                    partir du 2ème mois : <b>{DataDevis.fancyPrice(solly.toPayMonthly())} €</b></p>:<></>}
                                    
                            </>:<></>}
                        </td>
                        <td className="prices">
                            {axa.hasTarifs() && <>

                                {(params.periodicite=='M')?<>
                                    <b>{axa.fancyPrice(axa.echeanceOptions(false,'monthly'))}</b> par mois*<br/>
                                    <b>{axa.fancyPrice(axa.coutTotal())}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{axa.fancyPrice(axa.echeanceOptions(false,'yearly'))}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus
                                <p></p>
                                {(subsribeAxa&&(axaAlive||envDev))?<>
                                    <button
                                        className="subscribe"
                                        onClick={()=>this.props.setPage('details2')}>Souscrire cette offre</button>
                                    <CbLogos/>

                                    {(params.periodicite=='M')?<p>
                                    * L'acompte de <b>{axa.fancyPrice(axa.frais)}</b> inclut les frais de gestion et de
                                    courtage. Le mois en cours et le suivant seront prélevés sous quinzaine,
                                    soit un prélevement de <b>{axa.fancyPrice(axa.perception())}</b>. Puis, par mois : <b>{axa.fancyPrice(axa.mensuelSansFrais())}</b></p>
                                    :<p>
                                        L'acompte de <b>{axa.fancyPrice(axa.frais)}</b> inclut les frais de gestion et de
                                    courtage. Le mois en cours et les 11 mois suivants seront prélevés sous quinzaine,
                                    soit un prélevement de <b>{axa.fancyPrice(axa.perception())}</b>.
                                    </p>}
                                </>:<>
                                    {subsribeAxa?<p>
                                        La souscription de cette offre n'est pas possible en ligne actuellement.
                                        Vous pouvez réessayer plus tard ou nous contacter par téléphone du lundi au vendredi de 9h à 19h.
                                    </p>:<p>
                                        Souscription de cette offre uniquement par téléphone
                                        du lundi au vendredi de 9h à 19h.
                                    </p>}
                                    <p><b><a href="tel:0974772861" style={{'color':'#4fb6e9'}}>Appelez-nous pour souscrire</a></b></p>
                                    <p className="telephone_left">
                                        <a href="tel:0974772861">09 74 77 28 61</a>
                                    </p>
                                </>}
                            </>}
                        </td>
                        <td className="prices">
                            {fma.hasTarifs() && <>

                                {(params.periodicite=='M')?<>
                                    <b>{fma.fancyPrice(fma.mensuel())}</b> par mois*<br/>
                                    <b>{fma.fancyPrice(fma.coutTotal())}</b> par an TTC*<br/>
                                </>:<>
                                    <b>{fma.fancyPrice(fma.coutTotal())}</b> par an TTC*<br/>
                                </>}
                                * Frais de gestion et courtage inclus
                                <p></p>
                                {<>

                                    { this.props.enableClientSubscription ?
                                    <>
                                        <button
                                            className="subscribe"
                                            onClick={()=>this.props.setPage('details3')}>Souscrire cette offre</button>
                                        <CbLogos/>
                                        <a
                                        className="receive_devis"
                                        target="_blank"
                                        onClick={()=>this.props.setPage('details3')}
                                        >Éditer mon devis</a>
                                    </>:<>
                                        <p>
                                            La souscription en ligne est temporairement fermée. Appelez-nous
                                            du lundi au vendredi de 9h à 19h.
                                        </p>
                                        <p><b><a href="tel:0974772861" style={{'color':'#4fb6e9'}}>Appelez-nous pour souscrire</a></b></p>
                                        <p className="telephone_left">
                                            <a href="tel:0974772861">09 74 77 28 61</a>
                                        </p>
                                    </>}


                                    {(params.periodicite=='M')?<p>
                                    * Le comptant de <b>{fma.fancyPrice(fma.comptantMensuel()+fma.fraisCB())}</b> inclut les frais de gestion et de
                                    courtage ainsi que les deux premiers mois. 
                                    Il est composé d'un premier paiement CB de <b>{fma.fancyPrice(fma.fraisCB())} €</b>,
                                    puis d'un prélèvement de <b>{fma.fancyPrice(fma.comptant()-fma.fraisCB())}</b>.
                                    Puis, par mois à partir du 3ème mois : <b>{fma.fancyPrice(fma.mensuel())}</b> par mois</p>
                                    :<p>
                                    Le comptant de <b>{fma.fancyPrice(fma.annuel())}</b> inclut les frais de gestion et de
                                    courtage. Il est composé d'un premier paiement CB de <b>{fma.fancyPrice(fma.fraisCB())} €</b>,
                                    puis d'un prélevement de <b>{fma.fancyPrice(fma.comptant()-fma.fraisCB())}</b>.
                                    </p>}
                                </>}
                            </>}
                        </td>
                    </RowAggregate>
                </tbody>
        </table>
    }
}